import { FC, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hook'
import { LeaderBoardLayout } from '../../components'
import { LeaderBoardTabs } from './components'
import {
    CLEAR_DATA,
    CLEAR_SEARCH,
    fetchHallOfFame,
    fetchLeaderBoard,
    fetchMyProfile,
    fetchMyRankingLeaderBoard,
    searchUserTag,
} from './leaderBoardSlice'

type LeaderBoardProps = {
    isLeaderBoardLoading: (value: boolean) => void
}

export const LeaderBoard: FC<LeaderBoardProps> = ({ isLeaderBoardLoading }) => {
    const token = window.localStorage.getItem('token')
    const dispatch = useAppDispatch()

    const [selectedTime, setSelectedTime] = useState('all-time')
    const [selectedRankTab, setSelectedRankTab] = useState('top100')
    const [rankData, setRankData] = useState<LeaderBoardData[] | undefined>([])
    const [currentUserRankInfo, setCurrentUserRankInfo] = useState<
        usersRequest | undefined
    >()
    const [isLoading, setIsLoading] = useState(true)

    const { data, searchResults, status, user, hallOfFame } = useAppSelector(
        (state) => state.leaderBoard
    )

    const checkLoadingFinish = (value: boolean) => {
        //This will check loading finish in initial render only
        if (value === false) {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        isLeaderBoardLoading(isLoading)
    }, [isLoading])

    useEffect(() => {
        setRankData(data)
    }, [data])

    useEffect(() => {
        setCurrentUserRankInfo(user)
    }, [user])

    useEffect(() => {
        if (token && !hallOfFame) {
            dispatch(fetchHallOfFame())
        }
    }, [selectedRankTab, dispatch, token, hallOfFame])

    useEffect(() => {
        const userId = window.localStorage.getItem('FUTURE_USER_ID')
        dispatch(CLEAR_SEARCH())
        if (token) {
            dispatch(CLEAR_DATA())
            setRankData([])
            if (
                selectedRankTab === 'hallOfFame' &&
                selectedTime === 'all-time'
            ) {
                setSelectedRankTab('top100')
            }
            if (selectedRankTab === 'myRanking') {
                if (userId && userId !== 'null') {
                    dispatch(fetchMyProfile(selectedTime)).then((res: any) => {
                        onMyRankHandler(res.payload?.data[0]?.rank)
                    })
                }
            } else if (selectedRankTab === 'top100') {
                if (userId && userId !== 'null') {
                    dispatch(fetchMyProfile(selectedTime))
                }

                onTop100Handler()
            }
        }
    }, [selectedTime, selectedRankTab, token, dispatch])

    const onTimeFrameChangeHandler = (type: string) => {
        setSelectedTime(type)
    }

    const onTop100Handler = () => {
        dispatch(fetchLeaderBoard({ limit: 100, page: 1, time: selectedTime }))
    }

    const onMyRankHandler = (rank?: number) => {
        const userRank = rank ? rank : user?.data[0]?.rank || 0
        const page =
            rank !== null ? userRank && Math.floor(userRank / 100) + 1 : 1
        dispatch(
            fetchMyRankingLeaderBoard({
                limit: 100,
                page: page,
                userRank,
                time: selectedTime,
            })
        )
    }

    const onSearchUserTag = async (value: string) => {
        const data = {
            userTag: value,
            selectedTime,
        }
        await dispatch(searchUserTag(data))
    }

    return (
        <div style={{ opacity: isLoading ? 0 : 1 }}>
            <LeaderBoardLayout>
                <LeaderBoardTabs
                    onTimeFrameChangeHandler={onTimeFrameChangeHandler}
                    selectedTime={selectedTime}
                    data={rankData}
                    searchResults={searchResults.data}
                    user={currentUserRankInfo?.data?.[0]}
                    onSearchUserTag={onSearchUserTag}
                    status={status}
                    hallOfFame={hallOfFame}
                    OnSelectedRankTab={(tab: string) => setSelectedRankTab(tab)}
                    selectedRankTab={selectedRankTab}
                    isTabLoading={(value) => checkLoadingFinish(value)}
                />
            </LeaderBoardLayout>
        </div>
    )
}
